import React from 'react';
import { withTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import StyledButton from '../../../shared/components/styledButton/styledButton';
import i18n from '../../../utils/i18n';
import ACTIONS from '../../../redux/action';
import axios from '../../../shared/axios/axiosProxy';
import Navigation from '../components/navigation/navigation';
import { CAL_COM_KFT_URL } from './data/consultationLinks';

const KftConsultation = ({ ...props }) => {
	const dispatch = useDispatch();
	const searchID = useSelector((state) => state.company_store.searchID);

	// The "book" CTA below is a hard redirect (window.location.href), so its
	// write must be awaited before navigating away or it never reaches the
	// backend; the "continue" CTA is a normal in-app step transition.
	const persistConsultationChoice = async (value) => {
		dispatch(
			ACTIONS.addCompanyInfo({
				id: 'consultationChoice',
				data: value,
				stateObject: 'company_store',
			})
		);
		if (!searchID) return;
		try {
			await axios.patch(
				`/api/search/${searchID}`,
				{ consultationChoice: value },
				{ headers: { 'Content-Type': 'application/json' } }
			);
		} catch (error) {
			console.error(
				'Error saving consultationChoice to searchSchema:',
				error.response?.data || error.message
			);
		}
	};

	const handleContinue = () => {
		persistConsultationChoice('selfservice');
		props.handleNext(1);
	};

	const handleBookAppointment = async () => {
		await persistConsultationChoice('consultation');
		window.location.href = CAL_COM_KFT_URL;
	};

	return (
		<div className="stepContainer">
			<div className="SFInput">
				<p className="SFSubTitle">
					<span className="SFSubTitle">
						{i18n.t('searchflow.kftconsultationheading')}
					</span>
				</p>
				<p className="SFSubTitleHelper">
					{i18n.t('searchflow.kftconsultationtext')}
				</p>
				<div className="SFConsultationActions">
					<StyledButton
						className="SFConsultationBtnSecondary"
						color="NewNavBack"
						onClick={handleContinue}>
						{i18n.t('searchflow.kftconsultationcta1')}
					</StyledButton>
					<StyledButton
						className="SFConsultationBtnPrimary"
						color="NewNavForward"
						onClick={handleBookAppointment}>
						{i18n.t('searchflow.kftconsultationcta2')}
					</StyledButton>
				</div>
			</div>
			<Navigation
				step={3}
				handleBack={() => props.handleBack(1)}
				handleNext={() => props.handleNext(1)}
				openHelpForm={() => props.openHelpForm && props.openHelpForm()}
				disabledProp={false}
			/>
		</div>
	);
};

export default withTranslation()(KftConsultation);
